/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useEffect, useCallback } from 'react';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { Checkbox, FormLabelWrapper, Heading, TextInput } from '@restworld/ui-ds-base';

export const OtherCheckBoxInputField = React.memo(
  ({
    id,
    hasOtherOption,
    getValues,
    setValue,
    ...rest
  }: {
    hasOtherOption: HasOtherOptionType;
    id: string;
    getValues?: UseFormGetValues<any>;
    setValue: UseFormSetValue<any>;
  }) => {
    const [isChecked, onCheckboxToggle] = React.useState(false);
    const onCheckboxChange = useCallback(() => {
      onCheckboxToggle((p) => {
        setValue(id, '');
        return !p;
      });
    }, [id, setValue]);
    useEffect(() => {
      if (getValues && getValues(id)) onCheckboxToggle(true);
    }, [getValues, id]);
    return (
      <div className="flex flex-col gap-4 pl-1">
        <div className="flex flex-row gap-2 items-center">
          <Checkbox isChecked={isChecked} id={id} onClick={onCheckboxChange} />
          <FormLabelWrapper id={id} label={hasOtherOption?.formLabel}>
            <TextInput
              disabled={!isChecked}
              placeholder={hasOtherOption?.placeholder}
              id="others"
              type="text"
              {...rest}
            />
          </FormLabelWrapper>
        </div>
        <div className="pl-6">
          {!!hasOtherOption?.infoText && (
            <Heading size={6} color="muted" weight="normal">
              {hasOtherOption?.infoText}
            </Heading>
          )}
        </div>
      </div>
    );
  }
);
export type HasOtherOptionType = {
  infoText?: string;
  matchKey: string;
  fieldKey: string;
  placeholder?: string;
  formLabel?: string;
};
